var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrainHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 22,
    viewBox: "0 0 104 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.845 17.575C103.25 15.235 102.35 12.61 101.15 11.275L95.5699 5.05003C93.4399 2.66503 90.9799 1.40503 88.4149 1.40503H79.8799V21.415H99.6349C100.955 21.25 102.47 19.765 102.86 17.575H102.845ZM81.1399 20.635H80.3299V2.15503H88.4599C90.9049 2.15503 93.2749 3.37003 95.3149 5.65003L98.8999 9.64003H88.9399V10.405H99.5899L100.91 11.875C101.93 13.03 102.665 15.265 102.305 17.26C101.96 19.255 100.61 20.62 99.3799 20.635H81.1549H81.1399Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.125,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9849 20.11H0.169922V22H82.9849V20.11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8902 2.17004V20.5H41.2402V2.17004H75.8902ZM77.3902 0.670044H39.7402V22H77.3902V0.670044Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3199 2.17004V20.5H1.66992V2.17004H36.3199ZM37.8199 0.670044H0.169922V22H37.8199V0.670044Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4158 4.20996H43.7158V5.28996H73.4158V4.20996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4158 7.81006H43.7158V8.89006H73.4158V7.81006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4158 11.425H43.7158V12.505H73.4158V11.425Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8465 4.20996H4.14648V5.28996H33.8465V4.20996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8465 7.81006H4.14648V8.89006H33.8465V7.81006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8465 11.425H4.14648V12.505H33.8465V11.425Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 103.335,
    height: 21.33,
    fill: "white",
    transform: "translate(0.169922 0.670044)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainHome);
export default __webpack_public_path__ + "static/media/train_home.eb09a0cee1faee495ef3688477195bce.svg";
export { ForwardRef as ReactComponent };